import { render, staticRenderFns } from "./firstRecharge.vue?vue&type=template&id=70250322&scoped=true"
import script from "./firstRecharge.vue?vue&type=script&lang=js"
export * from "./firstRecharge.vue?vue&type=script&lang=js"
import style0 from "./firstRecharge.vue?vue&type=style&index=0&id=70250322&prod&lang=css"
import style1 from "./firstRecharge.vue?vue&type=style&index=1&id=70250322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70250322",
  null
  
)

export default component.exports